import { PaTableData, PaTableGroupConfig, PaTableGroupMeta } from '../models/pa-table.model';

export interface PaTableGroup {
  key: string;
  items: PaTableData[];
  meta?: PaTableGroupMeta;
}

export function getGroupKeyFromConfig(
  item: PaTableData,
  groupBy: PaTableGroupConfig | null,
): string {
  if (!groupBy) {
    return '';
  }

  const value = item[groupBy.field];

  if (value === null || value === undefined || value === '') {
    return '__empty__';
  }

  return String(value);
}

export function buildGroups(
  data: PaTableData[] | null,
  groupBy: PaTableGroupConfig | null,
): PaTableGroup[] {
  if (!data || !groupBy) {
    return [];
  }

  const groups: PaTableGroup[] = [];

  let currentKey: string | null = null;
  let currentItems: PaTableData[] = [];

  for (const row of data) {
    const key = getGroupKeyFromConfig(row, groupBy);

    if (currentKey === null) {
      currentKey = key;
      currentItems = [row];
      continue;
    }

    if (key === currentKey) {
      currentItems.push(row);
    } else {
      groups.push({
        key: currentKey,
        items: currentItems,
        meta: groupBy.meta?.[currentKey],
      });
      currentKey = key;
      currentItems = [row];
    }
  }

  if (currentKey !== null) {
    groups.push({
      key: currentKey,
      items: currentItems,
      meta: groupBy.meta?.[currentKey],
    });
  }

  return groups;
}

